import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { Label } from 'ng2-charts';
import { HomeService } from 'src/app/home/service/home.service';
import { CommunicationSubjectEnum } from 'src/app/shared/enum/communication-subject-enum';
import { CommunicationProxyService } from 'src/app/shared/services/communication-proxy.service';
import { Ranges } from '../../home-manager.component';
import { chartOptions } from './chart-contact-type-options';

export interface BarChartData {
  data: ChartContactType[];
}

export interface ChartContactType {
  count: number;
  contact_type: string;
}

@Component({
  selector: 'app-chart-contact-type',
  templateUrl: './chart-contact-type.component.html',
  styleUrls: ['./chart-contact-type.component.scss']
})
export class ChartContactTypeComponent implements OnInit {
  @Input() width;
  @Output() emitOnResize = new EventEmitter<number>();
  public maxScale;
  public ranges: Ranges = {
    field: 'last_update_date'
  };
  public barChartLabels: Label[] = [
    'Telefone', 'E-mail', 'Stand', 'Visita', 'Whatsapp'
  ];
  public barChartData: ChartDataSets[] = [];
  public barChartOptions: ChartOptions = chartOptions();
  public barChartType: ChartType = 'horizontalBar';
  public barChartLegend = true;
  public barChartPlugins = [pluginDataLabels];
  public chartColors: Array<any> = [
    {
      backgroundColor: ['#91BEFF', '#85AFEB', '#7AA0D6', '#6E90C2', '#6381AD', '#6381AD']
    }
  ];
  public loading = true;

  constructor(private service: HomeService, private communicationProxyService: CommunicationProxyService) {}

  ngOnInit(): void {
    this.communicationProxyService
      .subscribe(CommunicationSubjectEnum.onManagerFiltersUpdated, (res: any) => {
        const { begin, end } = res.message;
        this.ranges.from = begin;
        this.ranges.to = end;
        this.getCountContactType();
      });
  }

  getCountContactType(): void {
    this.loading = true;
    this.service.getCountContactType(this.ranges).subscribe((res: BarChartData) => {
      this.getBarChartInfos(res.data);
      this.loading = false;
    }, () => {
      this.loading = false;
    })
  }

  getBarChartInfos(chartContactType: ChartContactType[]): void {
    let chartDataSets = [];

    const data = chartContactType.map((item: ChartContactType) => item.count);

    chartDataSets.push({
      data,
      barPercentage: 0.6
    });

    this.barChartData = chartDataSets;
    this.maxScale = Math.max(...data);
    this.scaleMax(innerWidth);
  }

  onResize(event){
    this.scaleMax(event.target.innerWidth);
    this.emitOnResize.emit(event.target.innerWidth);
  }

  scaleMax(width: number) {
    if (width < 575) {
      return this.barChartOptions = chartOptions(this.maxScale * 1.3);
    }

    this.barChartOptions = chartOptions(this.maxScale * 1.1);
  }
}
